// utils/currencyHelper.js
const currencyHelper = (currencyCode) => {
  const symbols = {
    USD: '$',
    ZAR: 'R',
    EUR: '€',
    GBP: '£',
    JPY: '¥'
    // add more currencies as needed
  };

  return symbols[currencyCode] || currencyCode; // fallback to code if symbol not found
};

export default currencyHelper;
